<template>
    <div>
      <div>
        <!-- <div class="my-3">
          Use Mock Data: <a-switch class="mx-2" default-checked @change="val => useMock = val"></a-switch>
        </div> -->

        <a-steps v-model="currentStep">
            <a-step title="Add Merchant">
                <a-icon slot="icon" type="user" />
            </a-step>
            <a-step title="Select Countries">
                <a-icon slot="icon" type="flag" />
            </a-step>
            <a-step title="Select Currencies">
                <a-icon slot="icon" type="dollar" />
            </a-step>
            <a-step title="Assignment">
                <a-icon slot="icon" type="link" />
            </a-step>
        </a-steps>
        <a-divider />

        <div v-if="submitErrors.length">
          <a-result
            status="error"
            title="Submission Failed"
            sub-title="Please check and modify the following information before resubmitting."
          >
            <div class="desc">
              <p style="font-size: 16px;">
                <strong>The content you submitted has the following errors:</strong>
              </p>
              <p v-for="err in submitErrors" :key="err">
                <a-icon :style="{ color: 'red' }" class="mx-3" type="close-circle" /> {{err}}
              </p>
            </div>
          </a-result>
        <a-divider />
        </div>
        <div >
          <a-form-model
            ref="ruleForm"
            :model="form"
            :rules="rules"
            v-if="currentStep === 0"
            labelAlign="left"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            autocomplete="false"
          >
            <a-row :gutter="[36,0]" type="flex" class="d-flex justify-content-center">
              <a-col :md="12" :sm="18">
                <a-form-model-item  ref="merchantName" label="Merchant Name" prop="merchantName">
                  <a-input
                    v-model="form.merchantName"
                    @blur="
                      () => {
                        $refs.merchantName.onFieldBlur();
                      }
                    "
                  />
                </a-form-model-item>
                <a-form-model-item ref="accUsername" label="Account Username" prop="accUsername">
                  <a-input
                    v-model="form.accUsername"
                    @blur="
                      () => {
                        $refs.accUsername.onFieldBlur();
                      }
                    "
                  />
                </a-form-model-item>
                <a-form-model-item label="Merchant Gateway" required prop="merchantGateway">
                  <a-row type="flex">
                    <a-col flex="30px" v-if="this.merchantGateways === 'loading'">
                      <a-spin/>
                    </a-col>
                    <a-col flex="auto">
                      <a-select :disabled="this.merchantGateways === 'loading'" v-model="form.merchantGateway" placeholder="Choose the gateway for this merchant">
                        <a-select-option v-for="mG in merchantGateways" :key="mG.id" :value="mG.id">
                          {{mG.name}}
                        </a-select-option>
                      </a-select>
                    </a-col>
                  </a-row>
                  <a-row type="flex" class="my-2">
                      <a-button html-type="button" class="mr-3" size="large" type="default" @click="form.merchantGateway = undefined">Clear Selection </a-button>
                      <p class="my-3" style="font-size: 11px; line-height: 12px;">This will override any global settings.</p>
                  </a-row>
                </a-form-model-item>
                <a-form-model-item label="Is CVV required on every transaction?">
                  <a-radio-group v-model="form.cvvOnEach">
                    <a-radio value="1">
                      Yes
                    </a-radio>
                    <a-radio value="2">
                      No
                    </a-radio>
                  </a-radio-group>
                </a-form-model-item>
                <a-form-model-item v-if="form.cvvOnEach == '2'" label="Is CVV required on the first purchase?">
                  <a-radio-group v-model="form.cvvOnFirst">
                    <a-radio value="1">
                      Yes
                    </a-radio>
                    <a-radio value="2">
                      No
                    </a-radio>
                  </a-radio-group>
                </a-form-model-item>
                <a-form-model-item v-if="form.cvvOnEach == '1' || form.cvvOnFirst == '1'" label="CVV Exemption Amount" prop="cvvExemptionAmount">
                  <a-row type="flex">
                      <a-input-number
                        class="mr-3 mt-1"
                        :min="1"
                        v-model="form.cvvExemptionAmount"
                        :formatter="value => `$${formatMoney(value, 0)}`"
                      />
                  </a-row>

                </a-form-model-item>
                <a-form-model-item label="Test Mode">
                  <a-switch v-model="form.isTest" />
                </a-form-model-item>
              </a-col>
              <a-col :md="12" :sm="18">
                <a-form-model-item  ref="apiKey" label="API Key" prop="apiKey">
                  <a-input
                    v-model="form.apiKey"
                    @blur="
                      () => {
                        $refs.apiKey.onFieldBlur();
                      }
                    "
                  />
                </a-form-model-item>
                <a-form-model-item ref="accPassword" label="Account Password" prop="accPassword">
                  <a-input-password
                    v-model="form.accPassword"
                    @blur="
                      () => {
                        $refs.accPassword.onFieldBlur();
                      }
                    "
                  />
                </a-form-model-item>
                <a-form-model-item label="Monthly Limit" prop="monthlyLimit">
                  <a-row type="flex">
                      <a-input-number
                        v-if="!form.unlimitedML"
                        class="mr-3 mt-1"
                        :min="1"
                        v-model="form.monthlyLimit"
                        :formatter="value => `$${formatMoney(value, 0)}`"
                      />
                      <a-checkbox name="type" v-model="form.unlimitedML">
                        Unlimited
                      </a-checkbox>
                  </a-row>

                </a-form-model-item>
                <a-form-model-item label="Minimum Trxn:" prop="minTrxn">
                  <a-row type="flex">
                      <a-input-number
                        class="mr-3 mt-1"
                        :min="1"
                        v-model="form.minTrxn"
                        :formatter="value => `$${formatMoney(value, 0)}`"
                      />
                      <!-- <a-checkbox name="type" v-model="form.unlimitedML">
                        Unlimited
                      </a-checkbox> -->
                  </a-row>

                </a-form-model-item>
                <a-form-model-item label="Maximum Trxn:" prop="maxTrxn">
                  <a-row type="flex">
                      <a-input-number
                        class="mr-3 mt-1"
                        :min="1"
                        v-model="form.maxTrxn"
                        :formatter="value => `$${formatMoney(value, 0)}`"
                      />
                      <!-- <a-checkbox name="type" v-model="form.unlimitedML">
                        Unlimited
                      </a-checkbox> -->
                  </a-row>

                </a-form-model-item>
                <a-form-model-item label="Enable Merchant">
                  <a-radio-group v-model="form.enableMerchant">
                    <a-radio value="1">
                      Yes
                    </a-radio>
                    <a-radio value="2">
                      No
                    </a-radio>
                  </a-radio-group>
                </a-form-model-item>
                <a-form-model-item label="Set as Master">
                  <a-switch v-model="form.setAsMaster" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
          <div class="d-flex justify-content-center" v-if="currentStep === 1">
            <transfer-selection
              :listStyle="{
                width: '400px',
                height: 'auto',
              }"
              :loading="loadingCountries"
              :authed="authorizedCountries"
              :data="countriesData"
              :leftColumns="countriesLCols"
              :rightColumns="countriesRCols"
              :render="renderItem"
              :show-search="true"
              :show-select-all="true"
              :filter-option="(inputValue, item) => (item.name.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1 || item.code.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1)"
              :titles="['Available Countries', 'Authorized Countries']"
              @reload="getCountries"
              @change="handleCountriesChange">
            </transfer-selection>
          </div>
          <div class="d-flex justify-content-center" v-if="currentStep === 2">
            <transfer-selection
              :list-style="{
                width: '400px',
                height: 'auto',
              }"
              :loading="loadingCurrencies"
              :authed="authorizedCurrencies"
              :data="currenciesData"
              :show-select-all="true"
              :leftColumns="currenciesLCols"
              :rightColumns="currenciesRCols"
              :render="renderItem"
              :show-search="true"
              :filter-option="(inputValue, item) => (item.name.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1 || item.code.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1)"
              :titles="['Available Currencies', 'Authorized Currencies']"
              @reload="getCurrencies"
              @change="handleCurrenciesChange">
            </transfer-selection>
          </div>
          <div v-if="currentStep === 3">
            <div class="d-flex justify-content-around flex-wrap" >
              <div class="d-flex justify-content-center" style="flex-grow: 1; padding-left: 15%">
                <p class="text-center mx-4 my-2">Default Currencies:</p>
                <a-select
                  mode="multiple"
                  class="my-1"
                  style="width: 30%"
                  placeholder="Select default currencies"
                  @change="handleDefaultCurrencySelection"
                  @search="handleSearch($event, -1)"
                  :filter-option="false"
                >
                  <a-select-option v-for="currency in defaultAuthorizedCurrenciesMap" :key="currency.code">
                    {{ currency.code }}
                  </a-select-option>
                </a-select>
                <a-button html-type="button" class="mx-3 my-1" @click="applyDefault"> Apply<a-icon type="check" /> </a-button>
              </div>
              <a-select
                mode="multiple"
                class="my-1"
                style="width: 15%;"
                placeholder="Filter Countries"
                @change="s => this.countriesFilter = s"
                @search="v => this.countrySearch = v"
                :filter-option="false"
              >
                <a-select-option v-for="country in defaultAuthorizedCountriesMap" :key="country.id">
                  {{ country.name }}
                </a-select-option>
              </a-select>
            </div>
            <a-divider/>
            <div class="d-flex justify-content-center flex-wrap" >
              <empty v-if="authorizedCountriesMap.length == 0"/>
              <div class="row my-2" v-for="country in authorizedCountriesMap" :key="country.id" style="flex-basis: 33%">
                <div class="col-sm-4">
                  <p class="text-right mx-4 my-1">{{country.name}}</p>
                </div>
                <div class="col-sm-8">
                  <a-select
                    mode="multiple"
                    style="width: 100%"
                    placeholder="Please select the currencies"
                    :value="assignedCCs.filter(x => x.country_id === country.id)[0].currencies"
                    @change="handleCurrencySelection($event, country.id)"
                    @search="handleSearch($event, country.id)"
                    :filter-option="false"
                  >
                    <a-select-option v-for="currency in authorizedCurrenciesMap(country.id)" :key="currency.id">
                      {{ currency.code }}
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </div>
              <!-- <a-row type="flex">

              </a-row> -->
          </div>
          <a-divider />
          <a-row>
            <a-col :span="12" :offset="6" class="d-flex justify-content-center">
              <a-form-model-item>
                <a-button html-type="button" class="mx-2" type="default" @click.prevent="back"> <a-icon type="left" />Go back </a-button>
                <a-button html-type="button" class="mx-2" type="primary" v-if="currentStep < 3" @click.prevent="next"> Next<a-icon type="right" /> </a-button>
                <a-button :loading="creatingMerchant" html-type="button" class="mx-2" type="primary" v-if="currentStep == 3" @click="handleSubmit"> Create<a-icon type="check" /> </a-button>
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>

      </div>

    </div>
</template>

<script>
import axios from "axios"
import TransferSelection from "./TransferSelection"
import { Empty } from "ant-design-vue"
import { data as countriesM } from "./countriesMock.js"
import { data as currenciesM } from "./currenciesMock"
import { data as merchantGatewaysM } from "./merchantGatewaysMock"

const leftCountriesTableColumns = [
  {
    dataIndex: "code",
    title: "Code",
  },
  {
    dataIndex: "name",
    title: "Name",
  },
]
const rightCountriesTableColumns = [
  {
    dataIndex: "code",
    title: "Code",
  },
  {
    dataIndex: "name",
    title: "Name",
  },
]
const leftCurrenciesTableColumns = [
  {
    dataIndex: "code",
    title: "Code",
  },
  {
    dataIndex: "name",
    title: "Name",
  },
]
const rightCurrenciesTableColumns = [
  {
    dataIndex: "code",
    title: "Code",
  },
  {
    dataIndex: "name",
    title: "Name",
  },
]
export default {
  name: "add-merchant",
  components: {
    TransferSelection,
    Empty,
  },
  data() {
    return {
      merchantGatewaysM: merchantGatewaysM,
      currenciesM: currenciesM,
      countriesM: countriesM,
      useMock: false,
      currenciesLCols: leftCurrenciesTableColumns,
      currenciesRCols: rightCurrenciesTableColumns,
      countriesLCols: leftCountriesTableColumns,
      countriesRCols: rightCountriesTableColumns,
      loadingCurrencies: false,
      loadingCountries: false,
      merchantGateways: [],
      currenciesData: [],
      countriesData: [],
      countriesFilter: [],
      countrySearch: "",
      authorizedCountries: [],
      authorizedCurrencies: [],
      assignedCCs: [],
      defaultCurrenciesSelection: [],
      defaultSearch: "",
      searchFilter: "",
      showSearch: true,
      labelCol: { sm: { span: 10 } },
      wrapperCol: { sm: { span: 14 } },
      other: "",
      creatingMerchant: false,
      form: {
        unlimitedML: true,
        merchantName: "",
        accUsername: undefined,
        merchantGateway: undefined,
        apiKey: "",
        monthlyLimit: 0,
        minTrxn: 1,
        maxTrxn: 1000,
        enableMerchant: "2",
        cvvOnEach: "2",
        cvvOnFirst: "1",
        cvvExemptionAmount: 0,
        isTest: false,
        setAsMaster: false,
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      submitErrors: [],
      rules: {
        merchantName: [
          { required: true, message: "Please input Merchant Name", trigger: "blur" },
          { min: 1, max: 30, message: "Length must be less than 30 characters", trigger: "blur" },
        ],
        accUsername: [{ required: true, message: "Please input Account Username", trigger: "blur" },
          { min: 1, max: 30, message: "Length must be less than 30 characters", trigger: "blur" }],
        merchantGateway: [{ required: true, message: "Please select a merchant gateway", trigger: "change" }],
        apiKey: [
          { required: true, message: "Please provide an API Key", trigger: "blur" },
          { min: 1, max: 250, message: "API Key must be less than 250 characters", trigger: "change" },
        ],
        accPassword: [
          { required: true, message: "Please input the account password", trigger: "blur" },
          { pattern: "(?=.*[a-z])", message: "Password must contain at least 1 lowercase alphabetical character", trigger: "change" },
          { pattern: "(?=.*[A-Z])", message: "Password must contain at least 1 uppercase alphabetical character", trigger: "change" },
          { pattern: "(?=.*[0-9])", message: "Password must contain at least 1 numeric character", trigger: "change" },
          { pattern: "(?=.*[!@#$%^&*])", message: "Password must contain at least one special character", trigger: "change" },
          { pattern: "(?=.{6,})", message: "Password must be 6 characters or longer", trigger: "change" },
        ],
        monthlyLimit: [
          { required: true, type: "number", message: "Must be a number" },
        ],
      },
      currentStep: 0,
    }
  },
  computed: {
    defaultAuthorizedCurrenciesMap() {
      const authed = this.authorizedCurrencies.map(x => this.currenciesData.filter(y => y.id === x)[0])
      console.log(this.defaultSearch)
      return this.defaultSearch.length ? authed.filter(x => x.name.toLowerCase().includes(this.defaultSearch.toLowerCase()) || x.code.toLowerCase().includes(this.defaultSearch.toLowerCase())) : authed
    },
    defaultAuthorizedCountriesMap() {
      const authed = this.authorizedCountries.map(x => this.countriesData.filter(y => y.id === x)[0])
      return this.countrySearch.length ? authed.filter(x => x.name.toLowerCase().includes(this.countrySearch.toLowerCase()) || x.code.toLowerCase().includes(this.countrySearch.toLowerCase())) : authed
    },
    authorizedCountriesMap() {
      const authed = this.countriesFilter.length ? this.countriesFilter.map(x => this.countriesData.filter(y => y.id === x)[0]) : this.authorizedCountries.map(x => this.countriesData.filter(y => y.id === x)[0])
      return authed
    },
  },
  mounted() {
    console.log(process.env)
    this.getData()
  },
  methods: {
    formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
      try {
        decimalCount = Math.abs(decimalCount)
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount

        const negativeSign = amount < 0 ? "-" : ""

        const i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
        const j = (i.length > 3) ? i.length % 3 : 0

        return negativeSign + (j ? i.substr(0, j) + thousands : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "")
      } catch (e) {
        console.log(e)
      }
    },
    authorizedCurrenciesMap(countryId) {
      const authed = this.authorizedCurrencies.map(x => this.currenciesData.filter(y => y.id === x)[0])
      return this.searchFilter && this.searchFilter.id === countryId ? authed.filter(x => x.name.includes(this.searchFilter.value) || x.code.includes(this.searchFilter.value)) : authed
    },
    handleSearch(value, country) {
      if (country === -1) this.defaultSearch = value
      else {
        this.searchFilter = { value, id: country }
      }
    },
    applyDefault() {
      this.assignedCCs.forEach(ass => {
        if (this.countriesFilter.length) {
          if (this.countriesFilter.filter(x => x === ass.country_id).length === 1) { ass.currencies = this.defaultCurrenciesSelection }
        } else { ass.currencies = this.defaultCurrenciesSelection }
      })
    },
    handleDefaultCurrencySelection(selected) {
      this.defaultCurrenciesSelection = [...selected]
    },
    handleCurrencySelection(selected, countryId) {
      console.log(countryId)
      const curAssignedCountry = this.assignedCCs.filter(x => x.country_id === countryId)[0]
      if (curAssignedCountry) { curAssignedCountry.currencies = [...selected] } else {
        const country = this.authorizedCountries.filter(x => x.id === countryId)[0]
        console.log(country)
        this.assignedCCs.push({ country_id: country.id, currencies: [...selected] })
      }
    },
    getData() {
      this.getCurrencies()
      this.getCountries()
      this.getMerchantGateways()
    },
    getMerchantGateways() {
      this.merchantGateways = "loading"
      if (this.useMock) {
        this.merchantGateways = merchantGatewaysM.results.sort((a, b) => {
          return a.name < b.name ? -1 : 1
        })
      } else {
        return axios.get("/v1/api/gateways")
          .then(res => {
            this.merchantGateways = res.data.results.sort((a, b) => {
              return a.name < b.name ? -1 : 1
            })
          })
          .catch(err => console.error(err))
      }
    },
    getCountries() {
      this.loadingCountries = true
      this.countriesData = []
      this.authorizedCountries = []
      if (this.useMock) {
        this.loadingCountries = false
        this.countriesData = countriesM.results.map(x => { return { disabled: false, key: x.id, ...x } }).sort((a, b) => {
          return a.name < b.name ? -1 : 1
        })
        this.authorizedCountries = []
      } else {
        return axios.get("/v1/api/countries")
          .then(res => {
            this.loadingCountries = false
            this.countriesData = res.data.results.map(x => { return { disabled: false, key: x.id, ...x } }).sort((a, b) => {
              return a.name < b.name ? -1 : 1
            })
            this.authorizedCountries = []
          })
          .catch(err => console.error(err))
      }
    },
    getCurrencies() {
      this.loadingCurrencies = true
      this.currenciesData = []
      this.authorizedCurrencies = []
      if (this.useMock) {
        this.loadingCurrencies = false
        const currencies = currenciesM.results.map(x => { return { disabled: false, key: x.id, ...x } }).sort((a, b) => {
          return a.name < b.name ? -1 : 1
        })
        console.log(currencies)
        currencies.forEach(cur => {
          if (this.currenciesData.filter(x => x.id === cur.id).length === 0) { this.currenciesData.push(cur) }
        })
        this.authorizedCurrencies = []
      } else {
        return axios.get("/v1/api/currencies")
          .then(res => {
            this.loadingCurrencies = false
            const currencies = res.data.results.map(x => { return { disabled: false, key: x.id, ...x } }).sort((a, b) => {
              return a.name < b.name ? -1 : 1
            })
            console.log(currencies)
            currencies.forEach(cur => {
              if (this.currenciesData.filter(x => x.id === cur.id).length === 0) { this.currenciesData.push(cur) }
            })
            this.authorizedCurrencies = []
          })
          .catch(err => console.error(err))
      }
    },
    renderItem(item) {
      const customLabel = (
        <span class="custom-item">
          {item.name}
        </span>
      )

      return {
        label: customLabel, // for displayed item
        value: item.name, // for title and filter matching
      }
    },
    handleCountriesChange(targetKeys, direction, moveKeys) {
      console.log(targetKeys, direction, moveKeys)
      this.authorizedCountries = targetKeys
    },
    handleCurrenciesChange(targetKeys, direction, moveKeys) {
      console.log(targetKeys, direction, moveKeys)
      this.authorizedCurrencies = targetKeys
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          alert("submit!")
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      if (this.authorizedCurrencies && this.authorizedCurrencies.length > 0) {
        const dataToSend = { min_trxn: this.form.minTrxn, max_trxn: this.form.maxTrxn, cvv_each: this.form.cvvOnEach === "1", cvv_first: this.form.cvvOnFirst === "1", cvv_exemption_amount: this.form.cvvExemptionAmount, is_test: this.form.isTest, unlimitedML: this.form.unlimitedML, name: this.form.merchantName, username: this.form.accUsername, gateway_id: this.form.merchantGateway, api_key: this.form.apiKey, monthly_limit: this.form.monthlyLimit, is_enabled: this.form.enableMerchant === "1", set_master: this.form.setAsMaster, password: this.form.accPassword, merchant_currencies: this.authorizedCurrencies, merchant_countries: this.authorizedCountries, merchant_country_currencies: this.assignedCCs }
        this.creatingMerchant = true
        axios.post("/v1/api/user/merchant", { ...dataToSend }, {
          headers: {
            Authorization: "Bearer k5tpXc95Q7Tn7KOuII7doqVBZ2iz08EXY75peUewnX357tUTnQIJIwex85RN",
          },
        })
          .then(res => {
            this.creatingMerchant = false

            this.submitErrors = []
            if (res.data.success) {
              this.$notification.success({
                message: "Merchant Created Successfully",
                description:
                `The merchant: '${this.form.merchantName}' has successfully been created`,
              })
            } else {
              const errors = res.data.errors
              if (typeof (errors) === "object") {
                Object.values(errors).forEach(error => {
                  if (typeof (error) === "string") {
                    this.submitErrors.push(error)
                  } else {
                    error.forEach(err => {
                      this.submitErrors.push(err)
                    })
                  }
                })
              } else if (errors.length) {
                this.submitErrors = [...errors]
              }
              this.$notification.error({
                message: "Failed to create the merchant",
                description:
              `The merchant: '${this.form.merchantName}' could not be created`,
              })
            }
          })
          .catch(err => {
            console.log(err)
            this.creatingMerchant = false
            this.$notification.error({
              message: "Failed to create the merchant",
              description:
              `The merchant: '${this.form.merchantName}' could not be created.`,
            })
          })
      }
    },
    onChange(currentStep) {
      console.log("onChange:", currentStep)
      this.currentStep = currentStep
    },
    next() {
      if (this.currentStep === 0) {
        this.$refs.ruleForm.validate(valid => {
          if (valid) this.currentStep++
        })
      } else if (this.currentStep === 1) {
        if (this.authorizedCountries.length > 0) {
          this.currentStep++
          this.getCurrencies()
        }
      } else if (this.currentStep === 2) {
        if (this.authorizedCurrencies.length > 0) {
          this.assignedCCs = []
          for (let i = 0; i < this.authorizedCountries.length; i++) {
            this.assignedCCs.push({ country_id: this.authorizedCountries[i], currencies: [] })
          }
          this.currentStep++
        }
      } else if (this.currentStep === 3) {

      }
    },
    back() {
      if (this.currentStep) {
        this.currentStep--
      }
    },
  },
}
</script>
<style lang="less">
</style>
